import React, { useEffect } from "react";
import { Store__System, theme } from "@talentbait/shared-components";
import { ThemeProvider } from "styled-components";

import Actions from "../../Actions";
import { withRefluxStore, QualificationQuestionsStore } from "../../Stores";
import DraftCampaign from "./DraftCampaign";

function DraftCampaignContainer(props) {
  useEffect(() => {
    Actions.loadUserProfile({ loadOrganization: true });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <DraftCampaign {...props} />
    </ThemeProvider>
  );
}

export default withRefluxStore(
  DraftCampaignContainer,
  [Store__System, QualificationQuestionsStore],
  ["userProfile", "user", "organization", "formality", "questions", "selectedChatbotQuestion"]
);
